import ExcelJS from "exceljs";
import { calculateFields } from "../asset/calculations";

const createWorkbook = () => {
  const workbook = new ExcelJS.Workbook();

  for (const { sheet, fields } of [
    {
      sheet: "Assets catalogue",
      fields: [
        "Asset ID",
        "Asset name",
        "Supplier",
        "Category",
        "Total emissions (kgCO2e)",
        "A1-A2 materials and transport (kgCO2e)",
        "A3 Energy for manufacturing (kgCO2e)",
        "A4 delivery to site (kgCO2e)",
        "B8 In-use emissions (kgCO2e)",
        "Data accuracy rating",
      ],
    },
    {
      sheet: "A1 Manufacture materials",
      fields: [
        "Material",
        "Asset ID",
        "Asset name",
        "kg mass",
        "Emission factor type",
        "Emission factor value",
        "A1 materials (kgCO2e)",
      ],
    },
    {
      sheet: "A2 Manufacture transport",
      fields: [
        "Leg",
        "Material",
        "Asset ID",
        "Asset name",
        "Transport to manufacturer mode",
        "Transport to manufacturer - distance km",
        "A2 transport to manufacture (kgCO2e)",
      ],
    },
    {
      sheet: "A3 Energy",
      fields: [
        "Electricity source",
        "Asset ID",
        "Asset name",
        "Energy unit",
        "Emissions factor type",
        "Emissions factor kgCO2e",
        "A3 Energy for manufacturing (kgCO2e)",
      ],
    },
    {
      sheet: "A4 Delivery",
      fields: [
        "Leg",
        "Asset name",
        "Asset ID",
        "Delivery mode",
        "Distance km",
        "A4 delivery to site (kgCO2e)",
      ],
    },
    {
      sheet: "B8 in-use",
      fields: [
        "Asset ID",
        "Asset name",
        "Mass of insulating gas in equipment kg",
        "Guaranteed leak rate per year %",
        "Type of gas: SF6 or other (please specify)",
        "Global Warming Potential",
        "Calculated mass of leak per year kg",
        "Lifetime of asset (years)",
        "Total kgCO2e over lifetime",
      ],
    },
  ]) {
    const newSheet = workbook.addWorksheet(sheet);
    newSheet.addRow(fields);
  }

  return workbook;
};

const fillWorkbook = ({ data, workbook }) => {
  for (const _asset of data) {
    const asset = calculateFields({ data: _asset });
    const assetsWs = workbook.getWorksheet("Assets catalogue");
    const {
      product_id,
      details: { name, company_name, category, rag, moduleSubmissions },
      totals: { total, a1, a2, a3, a4, b8 },
    } = asset;
    assetsWs.addRow([
      product_id,
      name,
      company_name,
      category,
      total,
      a1 + a2,
      a3,
      a4,
      b8,
      rag,
    ]);

    const a1ws = workbook.getWorksheet("A1 Manufacture materials");
    for (const {
      material,
      mass,
      supplier_emission_factor,
      factor,
      kgCO2e,
    } of moduleSubmissions.a1) {
      const emission_factor_type =
        supplier_emission_factor > 0 ? "Custom" : "Default";
      a1ws.addRow([
        material,
        product_id,
        name,
        mass,
        emission_factor_type,
        factor,
        kgCO2e,
      ]);
    }

    const a2ws = workbook.getWorksheet("A2 Manufacture transport");
    for (const { leg, item, mode, distance, kgCO2e } of moduleSubmissions.a2) {
      a2ws.addRow([leg, item, product_id, name, mode, distance, kgCO2e]);
    }

    const a3ws = workbook.getWorksheet("A3 Energy");
    for (const {
      source,
      unit,
      supplier_emission_factor,
      factor,
      kgCO2e,
    } of moduleSubmissions.a3) {
      const emission_factor_type =
        supplier_emission_factor > 0 ? "Custom" : "Default";
      a3ws.addRow([
        source,
        product_id,
        name,
        unit,
        emission_factor_type,
        factor,
        kgCO2e,
      ]);
    }

    const a4ws = workbook.getWorksheet("A4 Delivery");
    for (const { leg, mode, distance, kgCO2e } of moduleSubmissions.a4) {
      a4ws.addRow([leg, name, product_id, mode, distance, kgCO2e]);
    }

    const b8ws = workbook.getWorksheet("B8 in-use");
    const {
      mass,
      leak_rate,
      gas_type,
      gwp,
      leak_mass,
      lifetime,
      total_kgco2e_lifetime,
    } = moduleSubmissions.b8;
    b8ws.addRow([
      product_id,
      name,
      mass,
      leak_rate,
      gas_type,
      gwp,
      leak_mass,
      lifetime,
      total_kgco2e_lifetime,
    ]);
  }
};

const exportToXLS = ({ data }) => {
  const workbook = createWorkbook();
  fillWorkbook({ data, workbook });
  return workbook;
};

export default exportToXLS;
